import { gql } from "@apollo/client";

export const GET_BUSINESS_INFO = gql`
  {
    master(order_by: { id: desc }, limit: 1) {
      company_name
      company_logo
    }
  }
`;
